import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Chip } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    tags: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.5),
        alignItems: 'center',
    },
    tag: {
        fontSize: '1.2rem',
        fontWeight: 500,
        height: '2em',
        padding: theme.spacing(0.5, 1),
        borderRadius: theme.shape.borderRadius,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        whiteSpace: 'nowrap',
        backgroundColor: '#ebf7fe',
        color: '#066298',
        border: '1px solid #066298',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: theme.shadows[2],
        },
    },
    // Animation classes for different sizes
    areSmall: {
        '& $tag': {
            fontSize: '0.75rem',
            height: '1.5em',
            padding: theme.spacing(0.25, 0.75),
        }
    },
    areMedium: {
        '& $tag': {
            fontSize: '1rem',
            height: '2.25em',
            padding: theme.spacing(0.5, 1.25),
        }
    },
    areLarge: {
        '& $tag': {
            fontSize: '1.125rem',
            height: '2.5em',
            padding: theme.spacing(0.75, 1.5),
        }
    }
}))

const TagCloud = ({ tags, size = 'small', className }) => {
    const classes = useStyles();

    if (!tags || tags.length === 0) return null;

    // Parse className to determine size
    const sizeClass = className && className.includes('are-')
        ? className.split(' ').find(cls => cls.startsWith('are-'))
        : '';

    const containerClass = `${classes.tags} ${sizeClass ? classes[sizeClass] : ''} ${className || ''}`;

    let tagContents = tags.map(tag => {
        return (
            <Chip
                className={classes.tag}
                key={tag}
                label={tag}
                size={size}
                clickable={false}
                variant="default"
            />
        )
    });

    return (
        <Box className={containerClass}>
            {tagContents}
        </Box>
    )
}

TagCloud.propTypes = {
    tags: PropTypes.array,
    className: PropTypes.string
}

export default TagCloud
